<template lang="pug">
  app-dialog-confirm(v-model="$_show" @confirm="deleteHoliday(holiday.id)")
      app-card-title.mt-5 Вы точно хотите удалить(отпуск/больничный)?
</template>

<script>
import { AppDialogToggable } from '@/components'
import { judgeService } from "@/_services";
import { mapState, mapMutations } from 'vuex'

export default {
  mixins: [AppDialogToggable],

  props: {
    holiday: Object
  },

  computed: {
    ...mapState('judgeReestr', ['currentJudge'])
  },
  methods: {
    ...mapMutations('judgeReestr', ['setJudgeInJudges']),

    deleteHoliday (id) {
      this.currentJudge.holiday = this.currentJudge.holiday.filter(item => item.id != id)
      if (this.updateJudge()) judgeService.deleteHoliday(id).then(data => console.log(data))
    },

    updateJudge () {
      this.currentJudge.signImage = ''
      judgeService.updateJudge(this.currentJudge).then(data => this.setJudgeInJudges(data))
      return true
    },
  }
}
</script>